import React, { Component } from 'react';
import Table from '../components/risk/Risk/Index'
import WebpackerReact from 'webpacker-react';

class RiskIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    updateDateFilter = (data) => {
        this.setState({
            data: data,
        })
    }

    //add update
    updateItem = risk => {
        this.setState({
            data: this.state.data.map(item => {
            if (risk.id === item.id) {
              return { ...item, 
                description: risk.description,
                risk_type: risk.risk_type,
                possible_involvement_array: risk.possible_involvement_array,
                risk_activity_id: risk.risk_activity_id,
                criterio_id: risk.criterio_id,
                probability: risk.probability,
                impact: risk.impact,
                risk_matrix_id: risk.risk_matrix.id,
                score: risk.score
              }
            }
            return item;
          })
        });
    }

    loadData = () => {
        fetch(this.props.urlLoadData, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                    risk_matrix={this.props.risk_matrix}

                    activities={this.props.activities}
                    criterios={this.props.criterios}
                    specific_areas={this.props.specific_areas}

                    criterio={this.props.criterio}
                    activity={this.props.activity}

                    user={this.props.user}

                    //form filter

                    updateDateFilter={this.updateDateFilter}
                    urldata={this.props.urlLoadData}
                />
            </React.Fragment>
        );
    }
}


export default RiskIndex;
WebpackerReact.setup({ RiskIndex });
